module.exports = __webpack_public_path__ + "static/fonts/Poppins-SemiBoldItalic.9841f3d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-SemiBoldItalic.ttf
// module id = 1032
// module chunks = 11